import React from 'react'

import Desktop from '~/containers/Desktop'
import Mobile from '~/containers/Mobile'

import FooterDesktop from './Footer.desktop'
import FooterMobile from './Footer.mobile'

const Footer: React.FC = (props) => {
  return (
    <>
      <Desktop>
        <FooterDesktop {...props} />
      </Desktop>

      <Mobile>
        <FooterMobile {...props} />
      </Mobile>
    </>
  )
}

export default Footer
